<div *ngIf="profile && isMultiHospital">
  <div *ngIf="isTooLong" (mouseout)="onMouseOut()" (mouseover)="onMouseOver()">
    <div *ngIf="!isHovered">
      <p class="solo-text" [ngClass]="{ 'solo-text-dark': isNight }">{{ fullHospitalsName }}</p>
    </div>
    <div *ngIf="isHovered" class="hovered">
      <div class="header">
        <p class="title">Services</p>
      </div>
      <div class="content">
        <div fxLayout="column" fxLayoutAlign="start start">
          <div *ngFor="let hospitalName of hospitalsName" class="text-header">
            <p class="text">{{ hospitalName }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!isTooLong">
    <p class="solo-text" [ngClass]="{ 'solo-text-dark': isNight }">{{ fullHospitalsName }}</p>
  </div>
</div>
